import { array, boolean, object, string } from "yup";

/**
 * Greeting Settings Validation Schema
 */
export const greetingValidationSchema = () => {
    const greetingDataSchema = array()
        .of(
            object().shape({
                languages: array().of(string().required()).min(1, "至少選擇一種語言").required("語言選擇為必填"),
                dialogues: array()
                    .of(
                        object().shape({
                            sentences: array()
                                .of(
                                    object().shape({
                                        key: string().trim().required("對話 key 為必填"),
                                        content: string().trim().required("招呼詞內容為必填"),
                                        audio_url: string()
                                            .trim()
                                            .test("valid-url-or-empty", "請輸入有效的URL", function (value) {
                                                if (!value || value.trim() === "") {
                                                    return true; // 允許空值
                                                }
                                                // 檢查是否為有效 URL
                                                try {
                                                    new URL(value);
                                                    return true;
                                                } catch {
                                                    return this.createError({
                                                        message: "請輸入有效的URL格式",
                                                    });
                                                }
                                            }),
                                        face: string().trim().default(""),
                                        action: string().trim().default(""),
                                    })
                                )
                                .min(1, "每個對話至少需要一句話")
                                .required("sentences 陣列為必填"),
                        })
                    )
                    .min(1, "每個語言組至少需要一個對話")
                    .required("dialogues 陣列為必填"),
            })
        )
        .min(0, "greetings 陣列不可為負數");

    const schema = {
        greetings: object()
            .shape({
                enabled: boolean().required("啟用狀態為必填"),
                data: array().when("enabled", {
                    is: true,
                    then: (schema) =>
                        greetingDataSchema.min(1, "啟用時至少需要一組招呼詞").required("greetings data 陣列為必填"),
                    otherwise: (schema) => array().notRequired(),
                }),
            })
            .required("greetings 為必填"),
    };
    return object().shape(schema);
};
